import http from "@/settings/apiSettings"

class CrmContactsDataService {
  save(data: any): Promise<any> {
    return http.clientComercialOdata.post("/CRM_Contacts", data);
  }


  update(key: string, data: any): Promise<any> {
    return http.clientComercialOdata.patch(`/CRM_Contacts(${key})`, data);
  }

  getById(key: string, expand = ''): Promise<any> {
    return http.clientComercialOdata.get(`/CRM_Contacts(${key})?${expand}`);
  }
}
export default new CrmContactsDataService();